const STORAGE_KEY = 'postLoginRedirect'
const SESSION_FLAG_KEY = 'postLoginRedirectUsed'
const EXPIRY_MS = 24 * 60 * 60 * 1000 // 24 hours

interface PostLoginRedirectData {
  path: string
  timestamp: number
}

export function setPostLoginRedirect(path: string): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ path, timestamp: Date.now() }),
  )
  // A fresh intent supersedes any prior "used" state in this tab.
  sessionStorage.removeItem(SESSION_FLAG_KEY)
}

export function getPostLoginRedirect(): string | null {
  if (sessionStorage.getItem(SESSION_FLAG_KEY)) {
    return null
  }
  return peekPostLoginRedirect()
}

// Reads the stored redirect ignoring the per-tab "used" flag. Use when the
// caller knows the redirect is still the right destination regardless of
// whether AuthenticatedRoute has already consumed it in this tab.
export function peekPostLoginRedirect(): string | null {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (!stored) return null

  try {
    const parsed: PostLoginRedirectData = JSON.parse(stored)
    const isExpired = Date.now() - parsed.timestamp > EXPIRY_MS
    if (isExpired) {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }
    return parsed.path
  } catch {
    return null
  }
}

export function clearPostLoginRedirect(): void {
  localStorage.removeItem(STORAGE_KEY)
}

export function markPostLoginRedirectUsed(): void {
  sessionStorage.setItem(SESSION_FLAG_KEY, 'true')
}

export function isPostLoginRedirectUsed(): boolean {
  return sessionStorage.getItem(SESSION_FLAG_KEY) === 'true'
}
